import React, {memo, useEffect} from 'react';
import {ReactComponent as OnlineClassIcon} from '../../assets/login/online-class.svg';
import {useInputWithFocus} from "common/hook/useInputWithFocus";
import {useFormik} from 'formik';
import {Link, useNavigate} from "react-router-dom";
import {PASSWORD_RECOVERY_TEXT, SEND_BUTTON_TEXT} from "entities/constants/constants";
import {useAppDispatch, useAppSelector} from "common/hook";

import {
    getRestorePasswordState
} from "features/model/selector/get-restore-password-state/getRestorePasswordState";
import {
    restorePasswordByEmail
} from "features/model/service/restore-password-email-state/restore-password-email-state";
import { setEmail} from "features/model/slice/resetPasswordEmailSlice";





export const RestoreEmailPasswordForm = memo(() => {
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([false]);
    const dispatch = useAppDispatch();

    const {email} = useAppSelector(getRestorePasswordState);
    const errors = useAppSelector((state) => state.resetPasswordEmail.errors);


    const resetPasswordEmailStatus = useAppSelector((state) => state.resetPasswordEmail.status);
    const navigate = useNavigate();

    useEffect(() => {
        if (resetPasswordEmailStatus === 'fulfilled') {
            navigate("/successful-restore-password");
        }
    }, [resetPasswordEmailStatus, navigate]);


    const formik = useFormik({
        initialValues: {
            email: email,
        },
        onSubmit: async (values) => {
            dispatch(setEmail(values.email));
            const result = await dispatch(restorePasswordByEmail({ email: values.email }));

            if (restorePasswordByEmail.fulfilled.match(result)) {

                // @ts-ignore
                dispatch(resetState());
            }
        },
    });


    return (
        <div className="app service-page">
            <div className="bg-box"><OnlineClassIcon/></div>
            <div className="form-box">
                <div className="sub-box">
                    <p className="h3 popup-title">{PASSWORD_RECOVERY_TEXT}</p>
                    <form
                        className="form"
                        onSubmit={formik.handleSubmit}
                    >
                            <div className={`field required ${isFilled[0] ? 'filled' : ''} ${errors.email ? 'error-field' : ''}`}>
                            <label
                                className={`field-name ${formik.values.email ? 'active-label' : ''}`}>Email</label>
                            <div className="inp-box">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control"
                                    onFocus={() => handleFocus(0)}
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                    onBlur={handleBlur}
                                />
                            </div>
                            {errors.email && <p className="field-error">{errors.email}</p>}
                        </div>
                        <button type="submit" className="btn full-width"><span>{SEND_BUTTON_TEXT}</span>
                        </button>
                        <div className="form-prompt">
                            <p>Вернуться ко <Link to="/">входу</Link></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});

